import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMarieStopesAsaba from "../Components/ProjPicMarieStopesNew";

const ProjectPageMarieStopesAsaba = () => {
    return (
        <>
            <Navbar />
            <ProjPicMarieStopesAsaba />
            <Footer />
        </>
    );
};

export default ProjectPageMarieStopesAsaba;
